import OptionalSettings from '@/docs-partials/optional-settings';
import * as React from 'react';
export default {
  OptionalSettings,
  React
};